import { render, staticRenderFns } from "./ClassToBeReviewed.vue?vue&type=template&id=1908e1e9"
import script from "./ClassToBeReviewed.vue?vue&type=script&lang=js"
export * from "./ClassToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./ClassToBeReviewed.vue?vue&type=style&index=0&id=1908e1e9&prod&lang=less&scope=true"
import style1 from "./ClassToBeReviewed.vue?vue&type=style&index=1&id=1908e1e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports